/* tslint:disable */
/* eslint-disable */
/**
 * WAG TP Request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WAGTPRequest,
    WAGTPRequestFromJSON,
    WAGTPRequestFromJSONTyped,
    WAGTPRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface BodyObeProvisioningObeProvisioningPost
 */
export interface BodyObeProvisioningObeProvisioningPost {
    /**
     * 
     * @type {WAGTPRequest}
     * @memberof BodyObeProvisioningObeProvisioningPost
     */
    request: WAGTPRequest;
}

export function BodyObeProvisioningObeProvisioningPostFromJSON(json: any): BodyObeProvisioningObeProvisioningPost {
    return BodyObeProvisioningObeProvisioningPostFromJSONTyped(json, false);
}

export function BodyObeProvisioningObeProvisioningPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyObeProvisioningObeProvisioningPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request': WAGTPRequestFromJSON(json['request']),
    };
}

export function BodyObeProvisioningObeProvisioningPostToJSON(value?: BodyObeProvisioningObeProvisioningPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request': WAGTPRequestToJSON(value.request),
    };
}


